import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map, publishReplay, refCount } from 'rxjs/operators';

import { Version } from './version';
import { VersionApplication } from './version.application.dto';
import { WindowService } from '../browser/window.service';
import { commitHash, managerVersion } from './manager.version';

@Injectable()
export class VersionService {
  public managerVersion: Version;
  public commitHash: string;

  constructor(private http: HttpClient, private windowService: WindowService) {
    this.managerVersion = Version.fromString(managerVersion);
    this.commitHash = commitHash;
  }

  public getOldManagerVersion(): Observable<VersionApplication> {
    return this.http
      .get(`${this.windowService.getOrigin()}/old-management/js/version.json`)
      .pipe(
        map((version: any) => version),
        publishReplay(1),
        refCount()
      );
  }

  public getNewManagerApplicationVersion(): VersionApplication {
    return {
      version: this.managerVersion.toString(),
      commit: this.commitHash
    };
  }
}
